module.exports = "input::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.red{\n  color:red\n}\n\n.green{\n  color:green\n}\n\n:host ::ng-deep .ck.ck-editor__editable {\n\tmin-height: 200px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/careers/careers.component.css
// module id = ./src/app/careers/careers.component.css
// module chunks = main